import { useState } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { VehicleInspectionType } from '../../../types/vehicleInspectionType';

interface Props {
  licensePlateNumber: string;
}

interface ReturnType {
  vehicleInspection?: VehicleInspectionType;
  lookup: ({ licensePlateNumber }: Props) => void;
  isLoading: boolean;
  error: boolean;
}

export const useVehicleInspection = (): ReturnType => {
  const [vehicleInspection, setVehicleInspection] = useState<VehicleInspectionType | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const vehicleInspectionSearch = async (licensePlateNumber: string) => {
    if (licensePlateNumber && !isLoading) {
      setIsLoading(true);
      try {
        const res = await apiClient.get<VehicleInspectionType>(ApiType.apimNafNoApi, {
          url: ApiPaths[ApiType.apimNafNoApi].vehicleInspection(licensePlateNumber),
        });
        setIsLoading(false);
        setVehicleInspection(res.data);
        setError(false);
      } catch (e) {
        setIsLoading(false);
        setError(true);
      }
    }
    return () => {};
  };

  const lookup = ({ licensePlateNumber }: Props) => {
    vehicleInspectionSearch(licensePlateNumber);
  };

  return { vehicleInspection, lookup, isLoading, error };
};
